import request from '@/utils/zsm-requets'
const order='/zsm/api/order/'
/** 创建订单
  authorFee
  authorId
  authorMobile
  authorName
  avatar
  backDate
  backFee
  backFlag
  backOperator
  backReason
  buyerAvatar
  buyerMobile
  buyerName
 */
export function createOrder(info) {
  return request({
    url: order+'create',
    method: 'post',
    params: info
  })
}



/** 删除订单
  params id 订单id
 */
export function deleteOrder(id) {
  return request({
    url: order+'create',
    method: 'post',
    params: {id}
  })
}

/* 获取订单列表
  params id 订单id
  params authorId 订单作者id
  params distId 分销者id
  params shopId 门店id
  params pageNo 当前页
  params pageSize 每页条数
  
  
 */
export function listDataOrder(params) {
  return request({
    url: order+'listData',
    method: 'post',
    params
  })
}


